import { useMemo } from "react";
import { AxnAttributeType } from "@idw-types/data/reference-data/axn";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";
import { sortStrings } from "@utils/string-util";
import { mapEntitiesWithNameAndIdToSelectOptions } from "@utils/select-option-mapping-util";
import { resources } from "@constants/hardcoded-strings";

type AttributeTypeSelectFormGroupProps = BaseSelectFormGroupProps & {
    axnAttributeTypes: Array<AxnAttributeType>
};

export const AttributeTypeSelectFormGroup = (props: AttributeTypeSelectFormGroupProps) => {
    const { axnAttributeTypes, onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth } = props;

    const attributeTypeOptions = useMemo(() => {
        return mapEntitiesWithNameAndIdToSelectOptions(axnAttributeTypes).sort((a, b) => sortStrings(a.label, b.label));
    }, [axnAttributeTypes]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-attribute-type-select`}
            label={resources.common.inputs.attributeType.label}
            ariaLabel={resources.common.inputs.attributeType.label}
            automationId={`${idPrefix}-attribute-type-select`}
            onChange={onChange}
            options={attributeTypeOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};